import { Component, OnInit, ViewChild } from '@angular/core';
import { DxDashboardControlComponent } from 'devexpress-dashboard-angular/ui/dashboard-control';
import { RADController } from "app/_controllers/radController";
import { AppComponent } from 'app/app.component';

@Component({
  selector: 'dashboard-carousel',
  templateUrl: './dashboard-carousel.component.html',
  styleUrls: ['./dashboard-carousel.component.css']
})
export class DashboardCarouselComponent implements OnInit {  
  dashboardData: any[] = [];
  activeDashBoardId: number = -1;  
  i: number;   
  @ViewChild(DxDashboardControlComponent, { static: false }) dashboardControl: DxDashboardControlComponent;    

  constructor(
    public app: AppComponent,
    private radController: RADController
  ) { }

  ngOnInit(): void {
    this.app.showLoader();        
    let carouselId = sessionStorage.getItem('qx_carousel_Id');
    this.radController.getDashboardCarouselData(carouselId).then((data) => { 
      sessionStorage.removeItem('qx_carousel_Id');     
      this.dashboardData = data;       
      this.i = 0;      
      this.app.hideLoader();
      this.flipDashboards();     
    });    
  }

  flipDashboards(): void {
    if (this.i === this.dashboardData.length) this.i = 0;

    this.activeDashBoardId = this.dashboardData[this.i].id;
    if (this.dashboardData[this.i].refreshInterval > 0 && this.dashboardData[this.i].refreshInterval < this.dashboardData[this.i].duration) {
      setTimeout(() => {        
        this.dashboardControl.instance.refresh();   
      }, this.dashboardData[this.i].refreshInterval * 1000);      
    }

    setTimeout(() => {      
      this.i++;
      this.flipDashboards();
    }, this.dashboardData[this.i].duration * 1000);
  }
}
